import * as wjcCore from '@mescius/wijmo';
import * as wjGridFilter from '@mescius/wijmo.grid.filter';
import * as wjMultirow from '@mescius/wijmo.grid.multirow';
import * as wjNav from '@mescius/wijmo.nav';

'use strict';

import {ViewChild, Component, AfterViewInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {HttpClient} from '@angular/common/http';
import {Store} from '@ngrx/store';
import {ToasterService} from 'angular2-toaster';
import {TranslocoService} from '@jsverse/transloco';
import {ActivePromotionConfig} from '../config/active-promotion.config';
import {GalleryComponent, GalleryItem, ImageItem} from '../ui/gallery/index';
import {asOrientDate, isOrientDate, DataService, OrientDBCollectionView} from '@cosbeni/database';
import {LoadUserAction} from '../ngrx/actions/user.action';
import {PaginationComponent} from 'ngx-bootstrap/pagination';

@Component({
    standalone: false,
    selector: 'cj-user-items',
    templateUrl: 'items.component.html',
    styleUrls: ['items.component.css']
})

export class ItemsComponent implements AfterViewInit {
    readonly: Boolean = true;
    @ViewChild('itemGrid') itemGrid: wjMultirow.MultiRow;
    @ViewChild('imageGallery') imageGallery: GalleryComponent;
    @ViewChild('itemTabPanel') itemTabPanel: wjNav.TabPanel;
    @ViewChild('paginationHeader') paginationHeader: PaginationComponent;
    @ViewChild('paginationFooter') paginationFooter: PaginationComponent;
    filter: wjGridFilter.FlexGridFilter;
    predicate: any = {
        id: null,
        place: '',
        lane: '',
        category: '',
        auctionResult: '',
        buyer: null,
        seller: null,
        name: '',
        description: '',
        eventDate: null,
        mode: '',
        pageIndex: 0,
        pageSize: 20,
    };
    currentPage: number = 1;
    screenWidth: number;
    user: any;
    now: Date = new Date();
    price: number = 0;
    item: any = {};
    items: OrientDBCollectionView;
    histories: wjcCore.CollectionView = new wjcCore.CollectionView([]);
    view: string = 'easy';
    mode: string = 'view';
    tableType: string = 'image';
    galleryItems: GalleryItem[];
    optionAuction: any[] = [];
    optionAuctionResult: any[] = [];
    optionCategory: any[] = [];
    optionLane: any[] = [];
    optionPlace: any[] = [];
    optionUnit: any[] = [];

    constructor(public store: Store<any>, public dataService: DataService, public toasterService: ToasterService, private transloco: TranslocoService, private route: ActivatedRoute, public router: Router, private http: HttpClient) {
        this.store.dispatch(new LoadUserAction());
        this.store.select<any>('activePromotionFeature').subscribe((digitalAuction: any) => {
            if (wjcCore.isObject(digitalAuction.user) && digitalAuction.user.loaded) {
                this.user = digitalAuction.user.user;
                this.route.queryParamMap.subscribe(params => {
                    this.predicate = {
                        id: null,
                        place: '',
                        lane: '',
                        category: '',
                        auctionResult: '',
                        buyer: null,
                        seller: null,
                        name: '',
                        description: '',
                        eventDate: null,
                        mode: '',
                        pageIndex: 0,
                        pageSize: 20,
                    };
                    if(params.has('view')) {
                        this.view = params.get('view');
                    }
                    if(params.has('tableType')) {
                        this.tableType = params.get('tableType');
                    }
                    if (params.has('id')) {
                        this.predicate.id = params.get('id');
                    }
                    if (params.has('place')) {
                        this.predicate.place = params.get('place');
                    }
                    if (params.has('lane')) {
                        this.predicate.lane = params.get('lane');
                    }
                    if (params.has('category')) {
                        this.predicate.category = params.get('category');
                    }
                    if (params.has('auctionResult')) {
                        this.predicate.auctionResult = params.get('auctionResult');
                    }
                    if (params.has('buyer')) {
                        this.predicate.buyer = params.get('buyer');
                    }
                    if (params.has('seller')) {
                        this.predicate.seller = params.get('seller');
                    }
                    if (params.has('name')) {
                        this.predicate.name = params.get('name');
                    }
                    if (params.has('description')) {
                        this.predicate.description = params.get('description');
                    }
                    if (params.has('eventDate')) {
                        this.predicate.eventDate = wjcCore.Globalize.parseDate(params.get('eventDate'), 'yyyyMMdd');
                    }
                    if (params.has('mode')) {
                        this.predicate.mode = params.get('mode');
                    }
                    if (params.has('pageIndex')) {
                        this.predicate.pageIndex = this.getNumber(params.get('pageIndex'));
                    }
                    if (params.has('pageSize')) {
                        this.predicate.pageSize = this.getNumber(params.get('pageSize'));
                    }
                    this.search();
                });
            }
        });
        this.items = new OrientDBCollectionView(dataService, ActivePromotionConfig.DATABASE, 'SELECT FROM DA_Item', 'DA_Item', '', 0, 20, true, true, false);
        this.items.url = ActivePromotionConfig.SERVER_URL;
        this.items.tokenName = ActivePromotionConfig.DATABASE + '_token';
        this.items.sortDescriptions.push(new wjcCore.SortDescription('auction.eventDate', false));
        this.items.sortDescriptions.push(new wjcCore.SortDescription('sort', true));
        this.items.fetchPlan = '*:0 auction:1';
        this.dataService.query({
            sql: 'SELECT FROM DA_Auction ORDER BY eventDate DESC',
            count: 'SELECT FROM DA_Auction ORDER BY eventDate DESC',
            fetchPlan: '*:1',
        }, ActivePromotionConfig.SERVER_URL).subscribe(data => {
            if (wjcCore.isArray(data.results)) {
                for (let auction of data.results) {
                    if (isOrientDate(auction.eventDate)) {
                        auction.eventDate = asOrientDate(auction.eventDate);
                        auction.display = wjcCore.Globalize.formatDate(auction.eventDate, 'yyyy/MM/dd HH:mm:ss') + ' ' + auction.place + ' ' + auction.lane;
                    }
                }
                this.optionAuction = data.results;
            }
        });
        this.dataService.query({
            sql: 'SELECT FROM DA_Master WHERE category =\'セリ結果\' order by sort',
            count: 'SELECT FROM DA_Master WHERE category =\'セリ結果\' order by sort',
            fetchPlan: '*:1',
        }, ActivePromotionConfig.SERVER_URL).subscribe(data => {
            if (wjcCore.isArray(data.results)) {
                this.optionAuctionResult = data.results;
            }
        });
        this.dataService.query({
            sql: 'SELECT FROM DA_Master WHERE category =\'商品種別\' order by sort',
            count: 'SELECT FROM DA_Master WHERE category =\'商品種別\' order by sort',
            fetchPlan: '*:1',
        }, ActivePromotionConfig.SERVER_URL).subscribe(data => {
            if (wjcCore.isArray(data.results)) {
                this.optionCategory = data.results;
            }
        });
        this.dataService.query({
            sql: 'SELECT FROM DA_Master WHERE category =\'レーン\' order by sort',
            count: 'SELECT FROM DA_Master WHERE category =\'レーン\' order by sort',
            fetchPlan: '*:1',
        }, ActivePromotionConfig.SERVER_URL).subscribe(data => {
            if (wjcCore.isArray(data.results)) {
                this.optionLane = data.results;
            }
        });
        this.dataService.query({
            sql: 'SELECT FROM DA_Master WHERE category =\'会場名\' order by sort',
            count: 'SELECT FROM DA_Master WHERE category =\'会場名\' order by sort',
            fetchPlan: '*:1',
        }, ActivePromotionConfig.SERVER_URL).subscribe(data => {
            if (wjcCore.isArray(data.results)) {
                this.optionPlace = data.results;
            }
        });
        this.dataService.query({
            sql: 'SELECT FROM DA_Master WHERE category =\'単位\' order by sort',
            count: 'SELECT FROM DA_Master WHERE category =\'単位\' order by sort',
            fetchPlan: '*:1',
        }, ActivePromotionConfig.SERVER_URL).subscribe(data => {
            if (wjcCore.isArray(data.results)) {
                this.optionUnit = data.results;
            }
        });
        this.resizeScreen();
    }

    resizeScreen(event?) {
        this.screenWidth = window.innerWidth;
    }

    ngAfterViewInit() {
        this.items.currentChanged.addHandler(this.onCurrentChanged, this);
        this.items.itemsSourceFunction = function (items: any[]) {
            for (let item of items) {
                if (wjcCore.isObject(item.auction) && isOrientDate(item.auction.eventDate)) {
                    item.auction.eventDate = asOrientDate(item.auction.eventDate);
                }
            }
            return items;
        };
    }

    onCurrentChanged(sender: any, args: wjcCore.EventArgs): void {
        this.now = new Date();
        if (this.items.currentItem != null && this.mode == 'view') {
            this.item = Object.assign({}, this.items.currentItem);
        }
    }

    pageChanged(event: any): void {
        this.predicate.pageIndex = event.page - 1;
        this.router.navigate(['/user/items'],{ queryParams: this.getQueryParams()});
    }

    numPages(event: any): void {
       if((this.predicate.pageIndex + 1) <= event){
          if(this.paginationHeader instanceof PaginationComponent){
              this.paginationHeader.selectPage(this.predicate.pageIndex + 1);
          }
           if(this.paginationFooter instanceof PaginationComponent){
               this.paginationFooter.selectPage(this.predicate.pageIndex + 1);
           }
       }
    }

    showItem(item: any) {
        this.router.navigate(['/user/item', item.uuid],);
    }

    createNew(): void {
        this.mode = 'edit';
    }

    showItems() {
        this.router.navigate(['/user/items'],{ queryParams: this.getQueryParams()});
    }

    search(): void {
        let where = ['published >= date(\'2000-01-01\',\'yyyy-MM-dd\')'];
        if (!wjcCore.isNullOrWhiteSpace(this.predicate.mode)) {
            if (this.predicate.mode == '自社落札済') {
                where.push('auction.eventDate <= date(\'' + wjcCore.Globalize.formatDate(new Date(), 'yyyy-MM-dd HH:mm:ss') + '\',\'yyyy-MM-dd HH:mm:ss\')');
                where.push('buyer = ' + this.user['@rid']);
            }
            if (this.predicate.mode == '自社落札中') {
                where.push('auction.eventDate > date(\'' + wjcCore.Globalize.formatDate(new Date(), 'yyyy-MM-dd HH:mm:ss') + '\',\'yyyy-MM-dd HH:mm:ss\')');
                where.push('@rid IN (SELECT item FROM (SELECT count(*), item FROM DA_History WHERE buyer = ' + this.user['@rid'] + ' GROUP BY item))');
            }
            if (this.predicate.mode == '落札可能') {
                where.push('auction.eventDate > date(\'' + wjcCore.Globalize.formatDate(new Date(), 'yyyy-MM-dd HH:mm:ss') + '\',\'yyyy-MM-dd HH:mm:ss\')');
            }
            if (this.predicate.mode == '終了済') {
                where.push('auction.eventDate <= date(\'' + wjcCore.Globalize.formatDate(new Date(), 'yyyy-MM-dd HH:mm:ss') + '\',\'yyyy-MM-dd HH:mm:ss\')');
            }
            if (this.predicate.mode == 'お気に入り') {
                where.push('followers IN [' + this.user['@rid'] + ']');
            }
        }
        if (wjcCore.isNumber(this.predicate.id)) {
            where.push('id = ' + this.predicate.id);
        }
        if (wjcCore.isDate(this.predicate.eventDate)) {
            where.push('auction.eventDate >= date(\'' + wjcCore.Globalize.formatDate(this.predicate.eventDate, 'yyyy-MM-dd') + '\',\'yyyy-MM-dd\')');
            where.push('auction.eventDate < date(\'' + wjcCore.Globalize.formatDate(wjcCore.DateTime.addDays(this.predicate.eventDate, 1), 'yyyy-MM-dd') + '\',\'yyyy-MM-dd\')');
        }
        if (!wjcCore.isNullOrWhiteSpace(this.predicate.place)) {
            where.push('auction.place = \'' + this.predicate.place + '\'');
        }
        if (!wjcCore.isNullOrWhiteSpace(this.predicate.lane)) {
            where.push('auction.lane = \'' + this.predicate.lane + '\'');
        }
        if (!wjcCore.isNullOrWhiteSpace(this.predicate.category)) {
            where.push('category = \'' + this.predicate.category + '\'');
        }
        if (!wjcCore.isNullOrWhiteSpace(this.predicate.auctionResult)) {
            where.push('auctionResult = \'' + this.predicate.auctionResult + '\'');
        }
        if (!wjcCore.isNullOrWhiteSpace(this.predicate.name)) {
            where.push('name LIKE \'%' + this.predicate.name + '%\'');
        }
        if (!wjcCore.isNullOrWhiteSpace(this.predicate.description)) {
            where.push('description LIKE \'%' + this.predicate.description + '%\'');
        }
        if(this.items instanceof OrientDBCollectionView){
            if(wjcCore.isNumber(this.predicate.pageSize))  {
                this.items.pageSize = this.predicate.pageSize;
            }
            this.items.filterOnServer = false;
            this.items.filterSpecial = where.join(' AND ');
            if(wjcCore.isNumber(this.predicate.pageIndex))  {
                this.items.pageIndex = this.predicate.pageIndex;
            }
            this.items.filterOnServer = true;
            if(this.paginationHeader instanceof PaginationComponent){
                this.paginationHeader.selectPage(this.predicate.pageIndex + 1);
            }
            if(this.paginationFooter instanceof PaginationComponent){
                this.paginationFooter.selectPage(this.predicate.pageIndex + 1);
            }
        }
    }

    resetPredicate() {
        this.predicate = {
            id: null,
            place: '',
            lane: '',
            category: '',
            auctionResult: '',
            buyer: null,
            seller: null,
            name: '',
            description: '',
            eventDate: null,
            mode: '',
            pageIndex: 0,
            pageSize: 20,
        };
        this.router.navigate(['/user/items'],this.getQueryParams());
    }

    getImageSrc(item, name): string {
        return ActivePromotionConfig.IMAGE_URL + item.id + '/' + name;
    }

    getCurrentImageSrc(name): string {
        return ActivePromotionConfig.IMAGE_URL + this.item.id + '/' + name;
    }

    addFollowers(item) {
        let sql = 'BEGIN\n';
        sql = sql + 'UPDATE DA_Item ADD followers = ' + this.user['@rid'] + ' WHERE @rid = ' + item['@rid'] + '\n';
        sql = sql + 'COMMIT RETRY 100\n';
        this.dataService.batch({sql: sql}, ActivePromotionConfig.SERVER_URL).subscribe((response: any) => {
                this.toasterService.pop('info', this.transloco.translate('user.favorites'), this.transloco.translate('user.added_message'));
                if (item.hasOwnProperty('followers') && wjcCore.isArray(item.followers)) {
                    item.followers.push(this.user['@rid']);
                } else {
                    item.followers = [this.user['@rid']];
                }
            },
            (error: any) => {
                this.toasterService.pop('error', this.transloco.translate('user.favorites'), this.transloco.translate('user.failed_message'));
            }
        );
    }

    removeFollowers(item) {
        let sql = 'BEGIN\n';
        sql = sql + 'UPDATE DA_Item REMOVE followers = ' + this.user['@rid'] + ' WHERE @rid = ' + item['@rid'] + '\n';
        sql = sql + 'COMMIT RETRY 100\n';
        this.dataService.batch({sql: sql}, ActivePromotionConfig.SERVER_URL).subscribe((response: any) => {
                this.toasterService.pop('info', this.transloco.translate('user.favorites'), this.transloco.translate('user.removed_message'));
                if (item.hasOwnProperty('followers') && wjcCore.isArray(item.followers) && item.followers.indexOf(this.user['@rid']) >= 0) {
                    let index = item.followers.indexOf(this.user['@rid']);
                    item.followers.splice(index, 1);
                }
            },
            (error: any) => {
                this.toasterService.pop('error', this.transloco.translate('user.favorites'), this.transloco.translate('user.failed_message'));
            }
        );
    }

    isFollowers(item) {
        let result = false;
        if (item.hasOwnProperty('followers') && wjcCore.isArray(item.followers) && item.followers.indexOf(this.user['@rid']) >= 0) {
            return true;
        }
        return result;
    }

    getNumber(data: any) {
        if (wjcCore.isString(data)) {
            data = data.replace(/,/g, '');
            if (!isNaN(parseInt(data)) && wjcCore.isNumber(parseInt(data))) {
                return parseInt(data);
            } else {
                return 0;
            }
        }
        if (wjcCore.isNumber(data)) {
            return data;
        }
        return 0;
    }

    getQueryParams() {
        let params = {};
        params['tableType'] = this.tableType;
        params['view'] = this.view;
        if(this.predicate.hasOwnProperty('mode') && !wjcCore.isNullOrWhiteSpace(this.predicate.mode)) {
            params['mode'] = this.predicate.mode;
        }
        if(this.predicate.hasOwnProperty('id') && wjcCore.isNumber(this.predicate.id)) {
            params['id'] = this.predicate.id;
        }
        if(this.predicate.hasOwnProperty('place') && !wjcCore.isNullOrWhiteSpace(this.predicate.place)) {
            params['place'] = this.predicate.place;
        }
        if(this.predicate.hasOwnProperty('lane') && !wjcCore.isNullOrWhiteSpace(this.predicate.lane)) {
            params['lane'] = this.predicate.lane;
        }
        if(this.predicate.hasOwnProperty('category') && !wjcCore.isNullOrWhiteSpace(this.predicate.category)) {
            params['category'] = this.predicate.category;
        }
        if(this.predicate.hasOwnProperty('auctionResult') && !wjcCore.isNullOrWhiteSpace(this.predicate.auctionResult)) {
            params['auctionResult'] = this.predicate.auctionResult;
        }
        if(this.predicate.hasOwnProperty('name') && !wjcCore.isNullOrWhiteSpace(this.predicate.name)) {
            params['name'] = this.predicate.name;
        }
        if(this.predicate.hasOwnProperty('description') && !wjcCore.isNullOrWhiteSpace(this.predicate.description)) {
            params['description'] = this.predicate.description;
        }
        if(this.predicate.hasOwnProperty('eventDate') && wjcCore.isDate(this.predicate.eventDate)) {
            params['eventDate'] = wjcCore.Globalize.formatDate(this.predicate.eventDate, 'yyyyMMdd');
        }
        if(this.predicate.hasOwnProperty('pageSize') && wjcCore.isNumber(this.predicate.pageSize))  {
            params['pageSize']  = this.predicate.pageSize;
        }
        if(this.predicate.hasOwnProperty('pageIndex') && wjcCore.isNumber(this.predicate.pageIndex))  {
            params['pageIndex']  = this.predicate.pageIndex;
        }
        return params;
    }
}

